export default __webpack_public_path__ + "static/media/personal_icon.bc8c2a1a.svg";